var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTablerBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 23.1667V24.5C12.0007 25.5609 12.4221 26.5783 13.1722 27.3284C13.9224 28.0786 14.9398 28.5 16.0007 28.5C17.0615 28.5 18.0789 28.0786 18.8291 27.3284C19.5792 26.5783 20.0007 25.5609 20.0007 24.5V23.1667M13.334 7.16667C13.334 6.45942 13.6149 5.78115 14.115 5.28105C14.6151 4.78095 15.2934 4.5 16.0007 4.5C16.7079 4.5 17.3862 4.78095 17.8863 5.28105C18.3864 5.78115 18.6673 6.45942 18.6673 7.16667C20.1985 7.8907 21.5039 9.01777 22.4434 10.4271C23.3829 11.8364 23.9212 13.4748 24.0007 15.1667V19.1667C24.101 19.9956 24.3946 20.7894 24.8577 21.4842C25.3209 22.1789 25.9407 22.7552 26.6673 23.1667H5.33398C6.06057 22.7552 6.6804 22.1789 7.14357 21.4842C7.60674 20.7894 7.90031 19.9956 8.00065 19.1667V15.1667C8.08006 13.4748 8.61839 11.8364 9.55792 10.4271C10.4974 9.01777 11.8028 7.8907 13.334 7.16667Z",
    stroke: "#262626",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerBell);
export default __webpack_public_path__ + "static/media/tabler_bell.22d5b1f8e4fea4ed0906195b326d5871.svg";
export { ForwardRef as ReactComponent };